function deleteUserDialogNew () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/delete-user-new/delete-user-dialog-new.html?$$REVISION$$'
  }
}

export { deleteUserDialogNew }
